import DiagramElement from './diagramElement';
import IWorkflowStepContainer from "../../../formability/form_builder/models/workflow/iworkflowStepContainer";
import {BooleanHelper} from '~/helpers/booleanHelper'

export default abstract class StepElement extends DiagramElement {
  step: IWorkflowStepContainer
  index: number

  constructor(parent: DiagramElement, step: IWorkflowStepContainer, isTermination: boolean, graphParent: DiagramElement, { isLinkConfigurable }: { isLinkConfigurable?: boolean } = {}) {
    super()

    this.parent = parent
    if (parent) {
      this.index = parent.children.length
      parent.children.push(this)
    }
    this.step = step
    this.isTermination = isTermination
    this.graphParent = graphParent
    if (BooleanHelper.isStrictBoolean(isLinkConfigurable)) this.isLinkConfigurable = isLinkConfigurable
  }

}